import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../AuthContext";
import { useLang } from "../LanguageContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const SESSION_KEY = "qw_analytics_session";

function getSessionId() {
  let s = localStorage.getItem(SESSION_KEY);
  if (!s) {
    s = "v-" + Math.random().toString(36).slice(2) + "-" + Date.now().toString(36);
    localStorage.setItem(SESSION_KEY, s);
  }
  return s;
}

function detectDevice() {
  const w = window.innerWidth;
  if (w < 640) return "mobile";
  if (w < 1024) return "tablet";
  return "desktop";
}

export function useAnalytics() {
  const location = useLocation();
  const { user } = useAuth();
  const { lang } = useLang();

  useEffect(() => {
    // Skip admin views — don't pollute analytics with the owner's traffic
    if (location.pathname.startsWith("/admin")) return;
    if (user?.role === "admin") return;

    const payload = {
      path: location.pathname,
      session_id: getSessionId(),
      referrer: (document.referrer || "").slice(0, 200),
      device: detectDevice(),
      language: lang,
    };

    // fire-and-forget
    axios.post(`${API}/analytics/pageview`, payload).catch(() => {});
  }, [location.pathname, user, lang]);
}
